import React from 'react';
import { Text, View } from 'react-native-web';
import { getSubCategoryId, num_3452562 } from '../../../../utils/DictionaryManagementUtils';
import FullPageSimulator from '../FullPageSimulator';
import ArrowInsideSmallSquareBtn from '../../AuxiliaryComponent/ButtonComponent/ArrowInsideSmallSquareBtn';
import { textPrimary_26_2 } from '../../AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================
const PayBillsEnterCodeFP = ({
  globJSON,
  selectedScreen,
  simPlatform,
  slideshowRefs,
}) => {
  const myScreen = globJSON.screens[selectedScreen];
  const subCategoryId = getSubCategoryId(myScreen);
  const { configurations } = globJSON;
  const { colors } = configurations.theme;

  const myStyles = {
    container: {
      paddingHorizontal: 7,
      height: 46,
      flexDirection: 'row',
      justifyContent: 'space-around',
    },
    inputTextBox: {
      width: 152,
      height: 46,
      backgroundColor: colors.app_background_color,
      borderColor: colors.border_color,
      borderWidth: 0.6,
      borderRadius: configurations.theme.radius.elements_shape_square ? 3 : 15,
      justifyContent: 'center',
      paddingHorizontal: 7,
    },
  };

  return (
    <FullPageSimulator
      globJSON={globJSON}
      simPlatform={simPlatform}
      headlineText={configurations.services[subCategoryId].select_bill.type_the_barcode_title}
      keyboardType="numbersKeyboard"
      slideshowRefs={slideshowRefs}
    >
      <View style={myStyles.container}>
        <View style={myStyles.inputTextBox}>
          <Text style={[textPrimary_26_2(globJSON, simPlatform), { width: 140 }]}>
            {num_3452562}
          </Text>
        </View>
        <ArrowInsideSmallSquareBtn
          globJSON={globJSON}
          isPrimaryCtaColorBackground
          perfectSquare
        />
      </View>
    </FullPageSimulator>
  );
};

export default PayBillsEnterCodeFP;
